module.exports = __webpack_public_path__ + "img/thermometer-title-m.13e9dc50.png";